import React, { useState, useEffect } from 'react';
import { documentsApi } from '../../api/documents';
import WidgetCard from './WidgetCard';
import WidgetModal from './WidgetModal';
import DocumentPanel from '../documents/DocumentPanel';

const MIME_ICONS = { 'application/pdf':'📄', 'image/jpeg':'🖼️', 'image/png':'🖼️', 'text/plain':'📃' };

export default function DocumentPreviewWidget({ recordId }) {
  const [docs, setDocs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    documentsApi.getForRecord(recordId).then(d => setDocs(d.documents||[])).catch(()=>{});
  }, [recordId]);

  return (
    <>
      <WidgetCard title="Documents" icon="📎" count={docs.length} onExpand={() => setModalOpen(true)}>
        {docs.length === 0 ? <p className="text-xs text-gray-400 text-center py-4">No documents</p> : (
          <div className="py-1">
            {docs.slice(0,3).map(d => (
              <div key={d.id} className="flex items-center gap-2 px-4 py-1.5 text-xs">
                <span className="flex-shrink-0">{MIME_ICONS[d.mime_type]||'📎'}</span>
                <span className="flex-1 truncate text-gray-700">{d.original_name}</span>
                <span className="text-[10px] text-gray-400">{new Date(d.created_at).toLocaleDateString('en-US',{month:'short',day:'numeric'})}</span>
              </div>
            ))}
            {docs.length > 3 && <p className="text-[10px] text-gray-400 text-center py-1">+{docs.length-3} more</p>}
          </div>
        )}
      </WidgetCard>
      <WidgetModal open={modalOpen} onClose={() => { setModalOpen(false); typeof setRefreshKey === "function" && setRefreshKey(k => k + 1); }} title="Documents" icon="📎" width="max-w-2xl">
        <DocumentPanel recordId={recordId} />
      </WidgetModal>
    </>
  );
}
